import React, { memo, useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import {
  uploadImage,
  uploadScreenshot,
  fetchAddressLookup,
  fetchDeliverySlots,
  resetDeliverySlots,
  verifyIdentity,
  clearData,
  setData,
  changeFormField,
  selectPlan,
  fetchPostOfficeDeliverySlots,
  fetchAddressComponentMappings,
  findAddressLookup,
  validatePostalCode,
  resetPostalCodeValidation,
  setPostalCodeValidation,
  fetchCityList,
  fetchDistrictList,
  fetchStreetList,
  fetchStoreList,
  resetDistrictList,
  resetStreetList,
  resetStoreList,
  fetchMyInfoDetails,
  getJumioDetails,
  fetchEmailOtp,
  validateEmailOtp,
  ekycValidation
} from "ducks/actions";
import {
  makeSelectCountries,
  makeSelectStates,
  makeSelectOtherCountries,
  makeSelectPrimaryDocTypes,
  makeSelectDocTypes,
  makeSelectSingpassDocTypeMapping,
  makeSelectMinimumAge,
  makeSelectDateOptions,
  makeSelectMonthOptions,
  makeSelectYearOptions,
  makeSelectIsUploadIDLater,
  makeSelectPageValidations,
  makeSelectDeliveryMethod,
  makeSelectIsFetchingData,
  makeSelectIsImageUploaded,
  makeSelectImageUploading,
  makeSelectImageUploaded,
  makeSelectPostalCodeOptions,
  makeSelectIsIdentityVerified,
  makeSelectIsIdentityVerificationFailed,
  makeSelectPersonalDetailsFormInitialValues,
  makeSelectPersonalDetailsForm,
  makeSelectHasAddressError,
  makeSelectVerifyIdentityPayload,
  makeSelectDeliveryDates,
  makeSelectCombinedDeliveryDates,
  makeSelectFreeDeliverySlots,
  makeSelectSpecialDeliverySlots,
  makeSelectDropIdentityValidations,
  makeSelectPrecheckoutInfo,
  makeSelectDetailsFromIccidVerification,
  makeSelectSimCount,
  makeSelectPlanDetails,
  makeSelectSelfActivationForm,
  makeSelectDeliveryMethods,
  makeSelectPostOfficeRegions,
  makeSelectPostOfficeDeliverySlots,
  makeSelectSelectedPostOffice,
  makeSelectPostalCodeValidation,
  makeSelectAddressComponentMappings,
  makeSelectCityList,
  makeSelectDistrictList,
  makeSelectStreetList,
  makeSelectStoreList,
  makeSelectEligiblePlans,
  makeSelectPhones,
  makeSelectMyInfo,
  makeSelectMyInfoIsUsed,
  makeSelectMyInfoDetails,
  makeSelectRawCountryData,
  makeSelectEmailOtpPayload,
  makeSelectEmailOtp,
  makeSelectValidateEmailOtpPayload,
  makeSelectEmailOtpParams,
  makeSelectIsValidatedEmail,
  makeSelectJumioIsUsed,
  makeSelectJumioCanPrefill,
  makeSelectJumioData,
  makeSelectJumioDetails,
  makeSelectSessionToken,
  makeSelectGuestOrder,
  makeSelectAppSettingJumioDetails,
  makeSelectAppSettingMyInfo,
  makeSelectReferralCode,
  makeSelectIsSimTypeEsim,
  makeSelectIsWalletPromoCode,
  makeSelectMyInfoAddressValid,
  makeSelectMyInfoContactNumberValid,
  makeSelectMyInfoIsInvalid,
  makeSelectEkycValidation,
  makeSelectMyInfoDobValid
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import validate from "validations";
import { forms, paths, MYINFO_PARAMS, JUMIO_PARAMS } from "utils/constants";
import history from "utils/history";
import {
  autoScrollToError,
  urlParam,
  gotoUrl,
  setMyInfoFieldToClear,
  changeFieldDOB,
  splitAddress,
  splitFullName,
  isUnifiedEKYCFlow,
  // replaceLocalhostToStaging,
  pathWithChannel,
  getChannelFromUrl,
  upper
} from "utils/helpers";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import find from "lodash/find";
import forEach from "lodash/forEach";
import includes from "lodash/includes";
import toLower from "lodash/toLower";
import Spinner, { styles } from "components/Spinner";
import { makeSelectOrderRef } from "ducks/selectors/order";
import Alert from "react-s-alert";
import useInterval from "hooks/useInterval";

const PersonalDetailsHOC = Component =>
  function Comp(props) {
    const {
      params,
      myInfoIsUsed,
      setMyInfoIsUsed,
      myInfoDetails,
      setMyInfoDetailsToForm,
      clearMyInfoUrlParam,
      clearAllMyInfoData,
      setJumioIsUsed,
      setJumioCanPrefill,
      setJumioDataToForm,
      jumioIsUsed,
      clearJumioUrlParam,
      clearAllJumioData,
      changeField,
      orderRef,
      token,
      appSettingJumioDetails,
      appSettingMyInfo,
      fetchDeliverySlots: callFetchDeliverySlots,
      fetchMyInfoDetails: callFetchMyInfoDetails,
      getJumioDetails: callGetJumioDetails,
      myInfoIsInvalid,
      setEkycValidation
    } = props;
    const [isJumioPolling, setIsJumioPolling] = useState(false);
    const [jumioPollingCount, setJumioPollingCount] = useState(0);

    const jumioPrefillForChannel = includes(
      get(appSettingJumioDetails, "prefill_channels"),
      getChannelFromUrl()
    );
    const jumioPollInterval = get(appSettingJumioDetails, "poll_interval");
    const jumioPollRetry = get(appSettingJumioDetails, "poll_retry");
    const jumioFailScanTryAgain = get(
      appSettingJumioDetails,
      "error.fail_scan_try_again"
    );
    const jumioFailScanManualIpt = get(
      appSettingJumioDetails,
      "error.fail_scan_manual_input"
    );
    const myinfoFailRetrieve = get(
      appSettingMyInfo,
      "error.fail_to_retrieve_try_again"
    );

    const mockpass =
      window.location.hostname === "localhost" && urlParam("mockpass");

    const onJumioFailed = () => {
      clearJumioUrlParam();
      clearAllJumioData();
      jumioFailScanTryAgain && Alert.error(jumioFailScanTryAgain);
      history.replace(pathWithChannel(paths.EKYC));
    };

    const onMyInfoFailed = () => {
      clearMyInfoUrlParam();
      clearAllMyInfoData();
      myinfoFailRetrieve && Alert.error(myinfoFailRetrieve);
      history.replace(pathWithChannel(paths.EKYC));
    };

    // if user click on cancel or any MyInfo error occur, page will go back to ekyc page
    // error & error-description is return by myinfo on the url params
    if (isUnifiedEKYCFlow()) {
      const myinfoErr = urlParam(MYINFO_PARAMS.ERROR);
      const jumioErr = urlParam(JUMIO_PARAMS.ERROR_CODE);
      if (jumioErr || myinfoErr) {
        jumioErr ? onJumioFailed() : onMyInfoFailed();
      }
    }

    useEffect(() => {
      !isEmpty(params) && callFetchDeliverySlots(params);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      const code = urlParam(MYINFO_PARAMS.CODE);
      const state = urlParam(MYINFO_PARAMS.STATE) === MYINFO_PARAMS.STATE_200;
      if (code && state) {
        clearMyInfoUrlParam();
        setMyInfoIsUsed(true);
        setJumioIsUsed(false);
        callFetchMyInfoDetails(
          {
            auth_code: code,
            redirect_uri: window.location.origin + window.location.pathname
            // redirect_uri: replaceLocalhostToStaging(
            //   window.location.origin + window.location.pathname
            // )
          },
          result => {
            if (result) setMyInfoDetailsToForm(result, changeField);
          }
        );
      }
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      // Add support to mock singpass in localhost
      if (mockpass) {
        setMyInfoIsUsed(true);
        setJumioIsUsed(false);
      }
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      // Redirects user back to ekyc page if Singpass account is missing certain information
      if (myInfoIsInvalid && isUnifiedEKYCFlow()) {
        setEkycValidation(true);
      } else {
        setEkycValidation(false);
      }
    }, [myInfoIsInvalid, setEkycValidation]);

    const processJumioResult = result => {
      // jumio always return idCountry whether its failed or success
      const idCountry = get(result, JUMIO_PARAMS.COUNTRY, null);
      if (idCountry) {
        setIsJumioPolling(false);
        // if REJECT_REASON is available or result
        // has less than 2 elements, its a error response.
        const isError =
          get(result, JUMIO_PARAMS.REJECT_REASON, null) ||
          Object.keys(result).length <= 2;
        if (isError) {
          onJumioFailed();
        } else {
          setJumioCanPrefill(true);
          clearJumioUrlParam();
          setJumioDataToForm(result, changeField);
        }
      } else {
        setIsJumioPolling(true);
      }
    };

    useEffect(() => {
      const isTransactionSuc =
        urlParam(JUMIO_PARAMS.TRANSACTION_STATUS) ===
        JUMIO_PARAMS.STATUS_SUCCESS;
      const hasTransactionRef = urlParam(JUMIO_PARAMS.TRANSACTION_REF);
      const jumioOrderRef = urlParam(JUMIO_PARAMS.CUSTOMER_INT_REF);
      const hasCustomerRef = orderRef
        ? jumioOrderRef === orderRef
        : !!jumioOrderRef;
      if (isTransactionSuc && hasTransactionRef && hasCustomerRef) {
        setIsJumioPolling(true);
        setJumioIsUsed(true);
        setMyInfoIsUsed(false);
      }
      // eslint-disable-next-line
    }, [token]);

    useInterval(
      () => {
        const transactionReference = urlParam(JUMIO_PARAMS.TRANSACTION_REF);
        if (jumioPollingCount >= jumioPollRetry || !jumioPrefillForChannel) {
          setIsJumioPolling(false);
          setJumioCanPrefill(false);
          clearJumioUrlParam();
          jumioPrefillForChannel &&
            jumioFailScanManualIpt &&
            Alert.error(jumioFailScanManualIpt);
        } else {
          callGetJumioDetails({ token, transactionReference }, result =>
            processJumioResult(result)
          );
        }
        setJumioPollingCount(jumioPollingCount + 1);
      },
      isJumioPolling && jumioPollingCount <= jumioPollRetry
        ? jumioPollInterval
        : null
    );

    if (
      (myInfoIsUsed && isEmpty(myInfoDetails) && !mockpass) ||
      (jumioIsUsed && isJumioPolling)
    ) {
      return <Spinner size={200} sx={styles.fullPage} />;
    }

    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  formValidations: makeSelectPageValidations(forms.PERSONAL_DETAILS_FORM),
  formValues: makeSelectPersonalDetailsForm(),
  preCheckoutData: makeSelectPrecheckoutInfo(),
  selfActivationData: makeSelectSelfActivationForm(),
  issuingStates: makeSelectStates(),
  issuingCountries: makeSelectCountries(),
  topCountries: makeSelectCountries(),
  otherCountries: makeSelectOtherCountries(),
  rawCountryData: makeSelectRawCountryData(),
  primaryDocTypes: makeSelectPrimaryDocTypes(),
  docTypes: makeSelectDocTypes(),
  singpassDocTypeMapping: makeSelectSingpassDocTypeMapping(),
  minimumAge: makeSelectMinimumAge(),
  monthOptions: makeSelectMonthOptions(),
  dateOptions: makeSelectDateOptions(),
  yearOptions: makeSelectYearOptions(),
  uploadIDLater: makeSelectIsUploadIDLater(),
  frontImageUploading: makeSelectIsFetchingData("primary_front_ImagesUpload"),
  backImageUploading: makeSelectIsFetchingData("primary_back_ImagesUpload"),
  frontImageUploaded: makeSelectIsImageUploaded("primary_front_ImagesUpload"),
  backImageUploaded: makeSelectIsImageUploaded("primary_back_ImagesUpload"),
  imageUploading: makeSelectImageUploading(),
  imageUploaded: makeSelectImageUploaded(),
  sim_count: makeSelectSimCount(),
  planDetails: makeSelectPlanDetails(),
  postalCodeOptions: makeSelectPostalCodeOptions(),
  isIdentityVerified: makeSelectIsIdentityVerified(),
  isIdentityVerificationFailed: makeSelectIsIdentityVerificationFailed(),
  isVerifyingIdentity: makeSelectIsFetchingData("verifyIdentity"),
  deliverySlotDates: makeSelectDeliveryDates(),
  combinedDeliverySlotDates: makeSelectCombinedDeliveryDates(),
  freeDeliverySlotTime: makeSelectFreeDeliverySlots(),
  specialDeliverySlotTime: makeSelectSpecialDeliverySlots(),
  deliveryMethods: makeSelectDeliveryMethods(),
  postOfficeRegions: makeSelectPostOfficeRegions(),
  postOfficeDeliverySlots: makeSelectPostOfficeDeliverySlots(),
  selectedPostOffice: makeSelectSelectedPostOffice(),
  postalCodeValidation: makeSelectPostalCodeValidation(),
  addressComponentMappings: makeSelectAddressComponentMappings(),
  cityList: makeSelectCityList(),
  districtList: makeSelectDistrictList(),
  streetList: makeSelectStreetList(),
  storeList: makeSelectStoreList(),
  billingAddressError: makeSelectHasAddressError(
    forms.PERSONAL_DETAILS_FORM,
    "billing"
  ),
  dropIdentityValidations: makeSelectDropIdentityValidations(),
  initialValues: state => {
    return {
      ...makeSelectPersonalDetailsFormInitialValues()(state),
      delivery_method: makeSelectDeliveryMethod()(state),
      ...makeSelectDetailsFromIccidVerification()(state)
    };
  },
  payload: makeSelectVerifyIdentityPayload(),
  phones: makeSelectPhones(),
  eligiblePlans: makeSelectEligiblePlans(),
  myInfo: makeSelectMyInfo(),
  myInfoIsUsed: makeSelectMyInfoIsUsed(),
  myInfoDetails: makeSelectMyInfoDetails(),
  jumioIsUsed: makeSelectJumioIsUsed(),
  jumioCanPrefill: makeSelectJumioCanPrefill(),
  jumioData: makeSelectJumioData(),
  jumioDetails: makeSelectJumioDetails(),
  otpParams: makeSelectEmailOtpPayload(),
  emailOtp: makeSelectEmailOtp(),
  emailOtpParams: makeSelectEmailOtpParams(),
  validateOtpParams: makeSelectValidateEmailOtpPayload(),
  isValidatedEmail: makeSelectIsValidatedEmail(),
  messageData: makeSelectPersonalDetailsForm(),
  token: makeSelectSessionToken(),
  orderRef: makeSelectOrderRef(),
  guestOrder: makeSelectGuestOrder(),
  appSettingJumioDetails: makeSelectAppSettingJumioDetails(),
  appSettingMyInfo: makeSelectAppSettingMyInfo(),
  referralCode: makeSelectReferralCode(),
  isSimTypeEsim: makeSelectIsSimTypeEsim(),
  isWalletPromoCode: makeSelectIsWalletPromoCode(),
  myInfoAddressValid: makeSelectMyInfoAddressValid(),
  myInfoContactNumberValid: makeSelectMyInfoContactNumberValid(),
  myInfoIsInvalid: makeSelectMyInfoIsInvalid(),
  ekycValidation: makeSelectEkycValidation(),
  myInfoDobValid: makeSelectMyInfoDobValid()
});

export const mapDispatchToProps = dispatch => {
  return {
    uploadImage: (...payload) => dispatch(uploadImage(payload)),
    uploadScreenshot: payload => dispatch(uploadScreenshot(payload)),
    fetchDeliverySlots: params => {
      dispatch(fetchDeliverySlots(params));
    },
    resetDeliverySlots: () => dispatch(resetDeliverySlots()),
    fetchAddressLookup: params => {
      dispatch(fetchAddressLookup(params));
    },
    resetVerifyIdentity: () => dispatch(clearData("verifyIdentity")),
    fetchPostOfficeDeliverySlots: params => {
      dispatch(fetchPostOfficeDeliverySlots(params));
    },
    fetchAddressComponentMappings: params => {
      dispatch(fetchAddressComponentMappings(params));
    },
    findAddressLookup: (params, callback) => {
      dispatch(findAddressLookup(params, callback));
    },
    validatePostalCode: (postal_code, field) => {
      dispatch(validatePostalCode({ postal_code }, field));
    },
    resetPostalCodeValidation: field => {
      dispatch(resetPostalCodeValidation(field));
    },
    setPostalCodeValidation: (field, data, loading) => {
      dispatch(setPostalCodeValidation(field, data, loading));
    },
    fetchCityList: params => {
      dispatch(fetchCityList(params));
    },
    fetchDistrictList: params => {
      dispatch(fetchDistrictList(params));
    },
    fetchStreetList: params => {
      dispatch(fetchStreetList(params));
    },
    fetchStoreList: params => {
      dispatch(fetchStoreList(params));
    },
    fetchEmailOtp: params => {
      dispatch(fetchEmailOtp(params));
    },
    validateEmailOtp: params => {
      dispatch(validateEmailOtp(params));
    },
    resetValidateEmailOtp: () => dispatch(clearData("validateEmailOtp")),
    resetDistrictList: () => {
      dispatch(resetDistrictList());
    },
    resetStreetList: () => {
      dispatch(resetStreetList());
    },
    resetStoreList: () => {
      dispatch(resetStoreList());
    },
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: field,
          value: value
        })
      );
    },
    setSelectedPhone: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.PHONES_FORM,
          field: field,
          value: value
        })
      );
    },
    selectPlan: plan => dispatch(selectPlan(plan)),
    clearAllJumioData: () => {
      dispatch(clearData("jumio"));
      dispatch(clearData("jumioDetails"));
    },
    getJumioDetails: (params, callback) => {
      dispatch(getJumioDetails(params, callback));
    },
    setJumioIsUsed: isUsed => {
      dispatch(
        setData({
          key: "jumio",
          data: { isUsed }
        })
      );
    },
    setJumioCanPrefill: canPrefill => {
      dispatch(
        setData({
          key: "jumio",
          data: { canPrefill }
        })
      );
    },
    setMyInfoIsUsed: isUsed => {
      dispatch(
        setData({
          key: "myInfo",
          data: { isUsed }
        })
      );
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: "myInfoIsUsed",
          value: isUsed
        })
      );
    },
    setEkycValidation: showMsgEkycValidationFailure =>
      dispatch(ekycValidation({ showMsgEkycValidationFailure })),
    fetchMyInfoDetails: (params, callback) => {
      dispatch(fetchMyInfoDetails(params, callback));
    },
    clearAllMyInfoData: () => {
      dispatch(clearData("myInfoDetails"));
      dispatch(clearData("myInfo"));
    },
    onSubmit: (navigate, payload, change) => {
      const {
        id_verification_required,
        identity_verified,
        skip_id_verification,
        skip_verification_and_navigate
      } = payload;

      if (id_verification_required && !identity_verified) {
        if (skip_id_verification) {
          dispatch(
            setData({
              key: "verifyIdentity",
              data: { success: true, loading: false }
            })
          );
          skip_verification_and_navigate && navigate();
        } else {
          dispatch(verifyIdentity(payload));
        }
      } else {
        navigate();
      }
    }
  };
};

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    clearMyInfoUrlParam: () => {
      gotoUrl(window.location.pathname, true, {
        code: null,
        state: null
      });
    },
    clearJumioUrlParam: () => {
      gotoUrl(window.location.pathname, true, {
        [JUMIO_PARAMS.TRANSACTION_STATUS]: null,
        [JUMIO_PARAMS.CUSTOMER_INT_REF]: null,
        [JUMIO_PARAMS.TRANSACTION_REF]: null,
        [JUMIO_PARAMS.ERROR_CODE]: null
      });
    },
    clearMyInfoFormFields: (fieldNameToClear = []) => {
      const changeField = dispatchProps.changeField;
      const fieldMap = setMyInfoFieldToClear(fieldNameToClear);
      forEach(fieldMap, fieldName => {
        changeField(fieldName, null);
      });
    },
    setMyInfoDetailsToForm: (myInfoDetails, changeField) => {
      const name = get(myInfoDetails, "name.value");
      const dobString = get(myInfoDetails, "dob.value", "");
      const email = get(myInfoDetails, "email.value");
      const nationalityCode = get(myInfoDetails, "nationality.code"); //iso2_code
      const uinfin = get(myInfoDetails, "uinfin", "").toUpperCase();
      const passexpirydate = get(myInfoDetails, "passexpirydate.value");
      const prefix = get(myInfoDetails, "mobileno.prefix.value");
      const areacode = get(myInfoDetails, "mobileno.areacode.value");
      const contactNumber = get(myInfoDetails, "mobileno.nbr.value");
      const block = get(myInfoDetails, "regadd.block.value");
      const building = get(myInfoDetails, "regadd.building.value");
      const floor = get(myInfoDetails, "regadd.floor.value");
      const postal = get(myInfoDetails, "regadd.postal.value");
      const street = get(myInfoDetails, "regadd.street.value");
      const unit = get(myInfoDetails, "regadd.unit.value");

      const [dobYear, dobMonth, dobDay] = dobString.split("-"); // e.g. 1998-06-06

      const nationality_iso2_code = get(
        ownProps.appSettings,
        `generic.singpass_nationality_iso2_override.${upper(nationalityCode)}`,
        nationalityCode
      );

      const rawNationalData = find(
        stateProps.rawCountryData,
        country => get(country, "iso2_code") === nationality_iso2_code
      );
      const nationality = find(
        stateProps.topCountries,
        country => get(country, "value") === get(rawNationalData, "iso3_code")
      );

      const passtype =
        uinfin && ["S", "T"].includes(uinfin.charAt(0))
          ? "nric"
          : toLower(get(myInfoDetails, "passtype.code"));
      const docTypeFromMyInfoPassType =
        get(stateProps?.singpassDocTypeMapping, passtype) || passtype;
      const doc_type = find(
        stateProps?.docTypes?.primary,
        docType => docType?.value === docTypeFromMyInfoPassType
      );

      changeField("full_name", name);
      changeField("email", email);
      changeField("nric", uinfin);
      changeField("doc_type", doc_type);
      changeField("passexpirydate", passexpirydate);
      changeField("nationality", nationality);
      changeField("dob", [dobDay, dobMonth, dobYear].join("-"));
      changeFieldDOB(
        changeField,
        stateProps.dateOptions,
        stateProps.monthOptions,
        stateProps.yearOptions,
        dobDay,
        dobMonth,
        dobYear
      );

      if (prefix && areacode) {
        changeField("country_code", `${prefix}${areacode}`);
      }

      changeField("contact_number", contactNumber);

      if (postal) {
        changeField("billing_zip_code", postal);
        changeField("billing_hse_blk_tower", block);
        changeField("billing_street_name", street);
        changeField("billing_building_name", building);
        changeField("billing_unit_no", `${floor}${floor && "-"}${unit}`);
        if (getChannelFromUrl() === "web") {
          changeField("delivery_zip_code", postal);
          changeField("delivery_hse_blk_tower", block);
          changeField("delivery_street_name", street);
          changeField("delivery_building_name", building);
          changeField("delivery_unit_no", `${floor}${floor && "-"}${unit}`);
        }
      }
    },
    setJumioDataToForm: (jumioData, changeField) => {
      const fullName = get(jumioData, "idLastName", "");
      const dob = JSON.parse(get(jumioData, "dateOfBirthParts", "{}"));
      const address = JSON.parse(get(jumioData, "idAddress", "{}"));
      const dobDay = get(dob, "day", "");
      const dobMonth = get(dob, "month", "");
      const dobYear = get(dob, "year", "");
      const nric = get(jumioData, "idNumber");
      const nationalityCode = get(jumioData, "idCountry"); //iso3_code
      const nationality = find(
        stateProps.topCountries,
        country => get(country, "value") === nationalityCode
      );

      changeField("nric", nric);
      changeField("nationality", nationality);
      changeField("dob", [dobDay, dobMonth, dobYear].join("-"));
      changeFieldDOB(
        changeField,
        stateProps.dateOptions,
        stateProps.monthOptions,
        stateProps.yearOptions,
        dobDay,
        dobMonth,
        dobYear
      );

      if (!isEmpty(fullName)) {
        const { name1 } = splitFullName(fullName);
        changeField("full_name", name1);
      }

      if (!isEmpty(address)) {
        const line1 = get(address, "line1", null);
        if (line1) {
          const { blk, street } = splitAddress(line1);
          if (blk) changeField("billing_hse_blk_tower", blk);
          if (street) changeField("billing_street_name", street);
        }
        changeField(
          "billing_unit_no",
          get(address, "line2", "").replace("#", "")
        );
        changeField("billing_zip_code", get(address, "postal"));
      }
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.PERSONAL_DETAILS_FORM,
    destroyOnUnmount: false,
    validate,
    onSubmitFail: () => {
      autoScrollToError();
    }
  }),
  memo
)(PersonalDetailsHOC(SmartRender));
